export const STORE_USER_DETAILS = 'STORE_USER_DETAILS';
export const TOGGLE_FORGOT_PASSWORD_MODE = 'TOGGLE_FORGOT_PASSWORD_MODE';
export const TOGGLE_USER_LOADER = 'TOGGLE_USER_LOADER';
//guest user
export const UPDATE_GUEST_USER_INFO = 'UPDATE_GUEST_USER_INFO';
export const SIGNUP_GUEST_USER = 'SIGNUP_GUEST_USER';
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const STORE_USER_INFO = 'STORE_USER_INFO';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';
export const TOGGLE_GUEST_USER_SIGNUP_LOADER = 'TOGGLE_GUEST_USER_SIGNUP_LOADER';
export const TOGGLE_COMPLETE_FLOW_LOADER = 'TOGGLE_COMPLETE_FLOW_LOADER';
export const SIGNUP_ON_RELOAD = 'SIGNUP_ON_RELOAD';
export const FETCH_USER_DETAILS = 'FETCH_USER_DETAILS';
export const SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER =
  'SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER';
export const SHOW_SKELETON_REPORT_LOADER = 'SHOW_SKELETON_REPORT_LOADER';
export const LINK_GUEST_USER = 'LINK_GUEST_USER';
//current user
export const SAVE_CURRENT_USER = 'SAVE_CURRENT_USER';
// show/hide download button
export const SHOW_DOWNLOAD_BUTTON = 'SHOW_DOWNLOAD_BUTTON';
//config
export const STORE_CONFIG_DATA = 'STORE_CONFIG_DATA';
export const SET_PARTNER_CONFIG_DATA = 'SET_PARTNER_CONFIG_DATA';
export const STORE_PUBLIC_CONFIG = 'STORE_PUBLIC_CONFIG';
export const TOGGLE_APP_LOADER = 'TOGGLE_APP_LOADER';
export const SET_ASSESSMENT_SLUG_PUBLIC_CONFIG = 'SET_ASSESSMENT_SLUG_PUBLIC_CONFIG';
export const SET_CONFIG_LOADER = 'SET_CONFIG_LOADER';
//case
export const STORE_CASE_INFO = 'STORE_CASE_INFO';
export const TOGGLE_PROCESS_CASE_LOADER = 'TOGGLE_PROCESS_CASE_LOADER';
export const STORE_ASSESSMENT_REPORT = 'STORE_ASSESSMENT_REPORT';
export const CLEAR_CASE_DATA = 'CLEAR_CASE_DATA';
export const FETCH_ASSESSMENT_REPORT_DETAILS = 'FETCH_ASSESSMENT_REPORT_DETAILS';
//modal
export const TOGGLE_ASSESSMENT_REPORT_MODAL = 'TOGGLE_ASSESSMENT_REPORT_MODAL';
export const TOGGLE_USER_AGREEMENT_MODAL = 'TOGGLE_USER_AGREEMENT_MODAL';
export const TOGGLE_CARE_TEAM_LIST_MODAL = 'TOGGLE_CARE_TEAM_LIST_MODAL';
//Assessment Report
export const STORE_ASSESSMENT_REPORT_DETAILS = 'STORE_ASSESSMENT_REPORT_DETAILS';
export const FETCH_ASSESSMENT_REPORT_AND_DOWNLOAD = 'FETCH_ASSESSMENT_REPORT_AND_DOWNLOAD';
export const SET_ASSESSMENT_REPORT_DOWNLOAD_LOADER = 'SET_ASSESSMENT_REPORT_DOWNLOAD_LOADER';
export const SET_ASSESSMENT_SHARE_POPUP_VIEW = 'SET_ASSESSMENT_SHARE_POPUP_VIEW';
export const SET_REPORT_CONFIG = 'SET_REPORT_CONFIG';
export const SET_CSAT_DEFAULT_CONFIG = 'SET_CSAT_DEFAULT_CONFIG';
export const SET_REPORT_TYPE = 'SET_REPORT_TYPE';
//Story
export const SET_STORY_PLAY_MODE = 'SET_STORY_PLAY_MODE';
//Case
export const FETCH_CASE_DETAILS = 'FETCH_CASE_DETAILS';
//Assessment
export const SET_ASSESSMENT_NAME = 'SET_ASSESSMENT_NAME';
export const PROCESS_CASE_AND_GET_DETAILS = 'PROCESS_CASE_AND_GET_DETAILS';
export const SET_ASSESSMENT_INFO = 'SET_ASSESSMENT_INFO';
//CSAT
export const TOGGLE_CSAT_FORM = 'TOGGLE_CSAT_FORM';
//Care Plan
export const SET_CARE_PLAN_CONFIG = 'SET_CARE_PLAN_CONFIG';
export const SET_CARE_PLAN_DATA = 'SET_CARE_PLAN_DATA';
// CareTeam
export const SET_CARE_TEAM_DATA = 'SET_CARE_TEAM_DATA';
export const SET_SELECTED_CARE_TEAM_DATA = 'SET_SELECTED_CARE_TEAM_DATA';
export const RESET_CARE_TEAM_DATA = 'RESET_CARE_TEAM_DATA';
export const TOGGLE_CARE_TEAM_DATA_LOADING = 'TOGGLE_CARE_TEAM_DATA_LOADING';
// Consultation
export const SET_CONSULT_CASE_DATA = 'SET_CONSULT_CASE_DATA';
export const TOGGLE_CONSULT_LOADING = 'TOGGLE_CONSULT_LOADING';
export const SET_CONSULT_ERROR_DATA = 'SET_CONSULT_ERROR_DATA';
export const RESET_CONSULT_CASE_DATA = 'RESET_CONSULT_CASE_DATA';
// Root level Modal
export const SET_MODAL_DATA = 'SET_MODAL_DATA';
export const RESET_MODAL_DATA = 'RESET_MODAL_DATA';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
